import Grid from '@mshops-components-library/splinter-grid';

export default Grid;
